import React from 'react';

import { Box } from '../Box';
import { Button } from '../Button';
import { Heading } from '../Typography';
import {
  cardContainerStyles,
  cardContentStyles,
  getBackgroundWithGradient,
} from './FieldNoteCard.styles';

export type FieldNoteCardProps = {
  /**
   * URL of the background image
   */
  backgroundImage: string;
  /**
   * Title text displayed on the card
   */
  title: string;
  /**
   * Text displayed on the action button
   */
  buttonLabel: string;
  /**
   * Callback when the card or button is clicked
   */
  onClick?: () => void;
  /**
   * Additional CSS class names
   */
  className?: string;
};

const FieldNoteCard = ({
  backgroundImage,
  title,
  buttonLabel,
  onClick,
  className,
  ...rest
}: FieldNoteCardProps) => {
  return (
    <Box
      display="flex"
      css={cardContainerStyles}
      className={className}
      {...rest}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flex-end"
        p={6}
        css={[cardContentStyles, getBackgroundWithGradient(backgroundImage)]}
      >
        <Box display="flex" flexDirection="column" gap={6}>
          <Heading size="sm" color="white" textAlign="left">
            {title}
          </Heading>
          <Button variant="primary" onClick={onClick}>
            {buttonLabel}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default FieldNoteCard;
